import { jsx as _jsx } from "react/jsx-runtime";
import { DotsItem } from '@nivo/core';
export const ActivePoint = ({ currentSlice, ...props }) => {
    return (_jsx("g", { children: currentSlice?.points.map(point => (_jsx(DotsItem, { x: point.x, y: point.y, datum: point.data, color: point.color, borderColor: "white", labelYOffset: props.pointLabelYOffset, size: 10, borderWidth: 2 }, point.id))) }));
};
